import { Directive, OnInit, ElementRef } from '@angular/core';
import { UserService } from '@app-services/user.service';


@Directive({
    selector: '[theme]',
    standalone: false
})

export class ThemeDirective implements OnInit {
  userTheme: any = {
    name: 'user',
    properties: {
      '--background': '#f6f7f9',
      '--on-background': '#000',
      '--primary': '#1976d2',
      '--on-primary': '#fff',
      '--secondary': '#a8a8a8',
      '--on-secondary': '#fff',
      '--light': '#f6f7f9',
      '--on-light': '#000',
      '--accent': '#fff',
      '--on-accent': '#000',
      '--error': '#E74E3C',
      '--on-error': '#fff'
    }
  };

  constructor(
    private _elementRef: ElementRef,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.userService
    .getUserProfile()
    .subscribe(user => {
    this.userTheme.properties = {
        '--background': '#fff',
        '--on-background': '#000',
       '--primary': user.companyPrimaryColor,
        '--on-primary': '#efefef',
       '--secondary': user.companyDarkPrimaryColor,
        '--on-secondary': '#fff',
        '--light': user.companyLightPrimaryColor || '#f6f7f9',
        '--on-light': '#333',
        '--accent': user.companyAccentColor,
        '--on-accent': '#000',
        '--error': '#E74E3C',
       '--on-error': '#fff',
    };
     this.updateTheme(this.userTheme);
    })
  }

  updateTheme(theme: any) {
    // project properties onto the element
    let root = document.documentElement;

    for (const key in theme.properties) {
      root.style.setProperty(
        key,
        theme.properties[key]
      );
    }
  }
}
